import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SentryService } from '@shared-lib/services/sentry.service';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private readonly sentryService = inject(SentryService);

  handleError(error: { originalError?: unknown }): void {
    console.error(error);
    this.sentryService.captureError(error.originalError ?? error);
  }
}
